import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-create-lock-dates-modal',
  templateUrl: './create-lock-dates-modal.component.html',
  styleUrls: ['./create-lock-dates-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateLockDatesModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
